import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { buildButton } from '../utils/buildButton.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
/** the object props for building a footer from Utils */

var ButtonObjectPropType = PropTypes.shape({
  /** function to be called on click */
  action: PropTypes.func,

  /** bsPrefix applied to button */
  "class": PropTypes.string,

  /** is button disabled */
  disabled: PropTypes.bool,

  /** content rendered inside the button */
  label: PropTypes.any
});
/** props for building a button by passing an element or building from Utils */

var ButtonPropType = PropTypes.oneOfType([PropTypes.element, ButtonObjectPropType]);
/** the props for creating a PageFooter button */

var PageFooterButtonsPropType = PropTypes.arrayOf(ButtonPropType);
/** renders the standard page footer used in Foundry */

var PageFooter = /*#__PURE__*/function (_Component) {
  function PageFooter() {
    var _this;

    _classCallCheck(this, PageFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, PageFooter, [].concat(args));

    _defineProperty(_this, "renderButtons", function () {
      var _this$props = _this.props,
          footerButtons = _this$props.footerButtons,
          footerButtonBarClass = _this$props.footerButtonBarClass;

      if (!footerButtons || !footerButtons.length) {
        return null;
      }

      var buttonBarClassName = _formatClassName(['page-footer-buttonbar', footerButtonBarClass]);

      return /*#__PURE__*/React.createElement("div", {
        className: buttonBarClassName
      }, footerButtons.map(_this.renderButton));
    });

    _defineProperty(_this, "renderButton", function (button, key) {
      if (typeof button === 'function') {
        return button;
      }

      if (!button.action) {
        return null;
      }

      return buildButton({
        func: button.action,
        label: button.label,
        bsPrefix: 'btn',
        variant: button["class"] || 'primary',
        disabled: button.disabled || false,
        props: {
          key: key
        }
      });
    });

    return _this;
  }

  _inherits(PageFooter, _Component);

  return _createClass(PageFooter, [{
    key: "render",
    value: function render() {
      var footerClass = this.props.footerClass;

      var pageFooterClassName = _formatClassName(['page-footer', footerClass]);

      return /*#__PURE__*/React.createElement("div", {
        className: pageFooterClassName
      }, this.renderButtons());
    }
  }]);
}(Component);

_defineProperty(PageFooter, "propTypes", {
  /** adds a class to the PageFooter button container */
  footerButtonBarClass: PropTypes.string,

  /** configures the buttons rendered in the footer */
  footerButtons: PageFooterButtonsPropType,

  /** adds a class to the PageFooter wrapper */
  footerClass: PropTypes.string
});

_defineProperty(PageFooter, "defaultProps", {
  footerButtons: [],
  footerClass: 'row'
});

PageFooter.displayName = "PageFooter";
export { PageFooter, PageFooterButtonsPropType };